import React, { useState } from 'react';
import { X, Sun } from 'lucide-react';
import { Link } from 'react-router-dom';

// Replaces the Christmas banner with summer Mediterranean season promo
export const SummerBanner = () => {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  return (
    <div className="relative text-white py-3 px-4"
         style={{ background: 'linear-gradient(90deg, hsl(199 89% 48%) 0%, hsl(155 100% 33%) 50%, hsl(28 90% 55%) 100%)' }}>
      <div className="mx-auto max-w-7xl flex items-center justify-center gap-3 text-center">
        <span className="text-2xl">☀️</span>
        <p className="font-semibold text-sm sm:text-base">
          Summer in the Balkans is here! 🏝️ Discover the Riviera, lakes and rooftops across Albania, Kosovo & North Macedonia
        </p>
        <span className="text-2xl">🌊</span>
        <button onClick={() => setOpen(false)} className="absolute right-4 top-1/2 -translate-y-1/2 hover:opacity-75" aria-label="Close">
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};
